import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';

import { regExpFindUnderscore } from '../../../constants/regExps';
import Edit from '../../common/forms/buttons/Edit';
import Cancel from '../../common/forms/buttons/Cancel';

export default function WorkerStatus ({
  title,
  currentStatus,
  statuses,
  handleChangeStatus
}) {
  const [showStatusOptions, setShowStatusOptions] = useState(false);

  const changeStatus = (status) => {
    setShowStatusOptions(!showStatusOptions);
    handleChangeStatus(status.target.value);
  };

  return (
    <div>
      <h4>{title} Status:</h4>

      {!showStatusOptions && (
        <div className='status-container'>
          <h2>
            <Badge color='success' className='text-capitalize'>
              {currentStatus.replace(regExpFindUnderscore, ' ')}
            </Badge>
          </h2>
          <Edit onClick={() => setShowStatusOptions(!showStatusOptions)} />
        </div>
      )}
      {showStatusOptions && (
        <div className='status-container'>
          <select
            className='styled-select select-status'
            onChange={changeStatus}
            autoFocus
          >
            <option value='0'>Select {title} Status</option>
            {Object.keys(statuses).map((status) => (
              <option value={statuses[status]} key={statuses[status]}>
                {statuses[status].replace(regExpFindUnderscore, ' ')}
              </option>
            ))}
          </select>
          <Cancel onClick={() => setShowStatusOptions(!showStatusOptions)} />
        </div>
      )}
    </div>
  );
}

WorkerStatus.propTypes = {
  title: PropTypes.string.isRequired,
  currentStatus: PropTypes.string.isRequired,
  statuses: PropTypes.object.isRequired,
  handleChangeStatus: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/app/workerDetails/WorkerStatus.js